function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0.33201954,
  y1: 0.1405981,
  x2: 0.58494806,
  y2: 0.68174773,
  id: "facebook_gradient_1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3457A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3B5998"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0.7137736,
  y1: 0.64688367,
  x2: 0.27134836,
  y2: 0.02999062,
  id: "facebook_gradient_2"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3457A0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F3F77"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0.49999663,
  y1: 0.17680335,
  x2: 0.49999663,
  y2: 0.85475487,
  id: "facebook_gradient_3"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3457A0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F3F77"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 1.2595077,
  y1: 0.79108125,
  x2: 0.04256791,
  y2: 0.371142,
  id: "facebook_gradient_4"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3457A0",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3251,
  stopColor: "#2A4C8D",
  stopOpacity: 0.3254902
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7045,
  stopColor: "#22427D",
  stopOpacity: 0.7058824
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F3F77"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0L39 0L39 38L0 38L0 0Z",
  id: "facebook"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook_mask"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#facebook"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "facebook-(3)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L39 0L39 38L0 38L0 0Z",
  id: "facebook-(3)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook_mask)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.97568 37.3494C3.6497 37.0036 1.02267 34.4439 0.667694 31.2029C-0.222565 23.0757 -0.222565 14.9241 0.667694 6.79681C1.02267 3.55612 3.6497 0.996445 6.97568 0.650574C15.3168 -0.216858 23.6829 -0.216858 32.024 0.650574C35.3503 0.996445 37.9773 3.55612 38.3323 6.79681C39.2226 14.9241 39.2226 23.0757 38.3323 31.2029C37.9773 34.4439 35.3506 37.0036 32.0243 37.3494C23.6832 38.2169 15.3168 38.2169 6.97568 37.3494Z",
  id: "Vector",
  fill: "url(#facebook_gradient_1)",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4173 0.57708C21.0155 -0.19236 13.5918 -0.19236 6.19001 0.57708C3.23864 0.884102 0.907368 3.1556 0.592266 6.03129C-0.197422 13.2433 -0.197422 20.4767 0.592266 27.6884C0.907368 30.5644 3.23864 32.8359 6.19001 33.1426C13.5918 33.9123 21.0155 33.9123 28.417 33.1426C31.3687 32.8359 33.6999 30.5644 34.0148 27.6884C34.8047 20.4767 34.8047 13.2433 34.0148 6.03129L34.0148 6.03129C33.6999 3.1556 31.369 0.884102 28.4173 0.57708Z",
  transform: "translate(2.196289 2.1401367)",
  id: "Vector",
  fill: "url(#facebook_gradient_2)",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.083313 0.787995C0.438286 4.02869 3.06532 6.58837 6.39159 6.93424C14.7327 7.80167 23.0988 7.80167 31.4399 6.93424C34.7662 6.58837 37.393 4.02869 37.7479 0.787995C37.7768 0.52533 37.8045 0.262665 37.8315 0L0 0C0.0267792 0.262665 0.054451 0.52533 0.083313 0.787995Z",
  transform: "translate(0.58496094 30.41504)",
  id: "Vector",
  fill: "url(#facebook_gradient_3)",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.3111 5.9949L3.3111 10.4727L0 10.4727L0 16.0168L3.3111 18.9064L3.3111 31.6697C7.29881 31.6508 11.2862 31.4348 15.2683 31.0208C18.5946 30.675 21.2213 28.1153 21.5763 24.8743C22.2386 18.8272 22.4079 12.7668 22.0845 6.71274L15.1951 0L9.46346 0C6.06548 0 3.3111 2.68405 3.3111 5.9949Z",
  transform: "translate(16.75586 6.3286133)",
  id: "Vector",
  fill: "url(#facebook_gradient_4)",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1267 31.4447L10.1267 16.0168L14.6488 16.0168L15.1951 10.4727L10.1267 10.4727L10.1267 6.95221C10.1267 6.17465 10.7736 5.54437 11.5716 5.54437L15.1951 5.54437L15.1951 0L9.46346 0C6.06548 0 3.3111 2.68405 3.3111 5.9949L3.3111 10.4727L0 10.4727L0 16.0168L3.3111 16.0168L3.3111 31.6697C5.58346 31.6589 7.85552 31.5838 10.1267 31.4447Z",
  transform: "translate(16.75586 6.3286133)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "38px",
    viewBox: "0 0 39 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.fa20af2d.svg";
export { ForwardRef as ReactComponent };